import { Identifiable } from "../app/models/Identifiable";
import { WebUser } from "../app/models/WebUser";
import getId from "./getId";

const normalizeName = (value?: string | null): string => (value || "").trim().toLowerCase();

const getLoggedInAccountId = (user?: WebUser | null): string => {
  if (!user) {
    return "";
  }
  return getId(user.account) || getId(user.accountIds);
};

const getLoggedInAccountNames = (user?: WebUser | null): string[] => {
  if (!user) {
    return [];
  }

  return [user.account?.displayName, user.accountIds?.displayName, user.name, [user.firstName, user.lastName].filter(Boolean).join(" ")]
    .map(normalizeName)
    .filter(Boolean);
};

/**
 * Zwraca displayName konta powiązanego z biletem/rezerwacją, gdy to nie jest
 * konto obecnie zalogowanego użytkownika (inne idoki lub inna nazwa).
 */
export const getOtherAccountDisplayName = (
  itemAccount?: Identifiable | null,
  user?: WebUser | null,
): string | null => {
  const displayName = itemAccount?.displayName?.trim();
  if (!displayName) {
    return null;
  }

  const itemId = getId(itemAccount);
  const loggedId = getLoggedInAccountId(user);

  if (itemId && loggedId) {
    return itemId !== loggedId ? displayName : null;
  }

  const namesDiffer = !getLoggedInAccountNames(user).includes(normalizeName(displayName));
  return namesDiffer ? displayName : null;
};
